// Caracteres sin ambigüedades visuales (sin 0/O, 1/l/I)
const CHARS = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789'

/**
 * Genera una contraseña aleatoria usando la API criptográfica del navegador.
 *
 * Uso:
 *   const password = generatePassword()     // 12 caracteres
 *   const corta = generatePassword(8)
 */
export function generatePassword(length = 12) {
  const values = new Uint32Array(length)
  crypto.getRandomValues(values)
  return Array.from(values, (v) => CHARS[v % CHARS.length]).join('')
}
